import {useEffect, useMemo} from 'react';
import {useDispatch} from 'react-redux';

//utils
import {detailsNavigationIds} from '@stencil/hotels-utils/src/get-details-navigation-id-and-values';
import {isValidArray} from '@stencil/hotels-utils/src/common-utils';

//component
import Modal, {useModal} from '@stencil/hotels-modal-component';
import DinningModalUI from '@stencil/gi-components/src/DinningUIModal/DinningModalUI';
import DiningCarousel from './DiningCarousel/DiningCarousel';

//omniture
import {omnitureThunk, omnitureConfig, omnitureUtils} from '@stencil/omniture-analytics/src';
import {DetailsPageComponents} from '@stencil/omniture-analytics/src/constants/details';

//styles
import * as S from './DiningUI.styles';

const DiningUI = ({data = [], header = 'Food & Dining', allRules = []}) => {
  const dispatch = useDispatch();
  const {isModalOpen, openModal, closeModal} = useModal();

  useEffect(() => {
    omnitureUtils.setLoadedComponents('AltAccoFoodDining');
  }, []);

  const onViewAllClick = () => {
    openModal();
    dispatch(
      omnitureThunk(omnitureConfig.pages.DetailsUnif, omnitureConfig.events.ctaClick, {
        cta: {
          name: `${DetailsPageComponents.AltAccoFoodDining}_Clicked`,
          type: omnitureConfig.ctaType.Button,
          componentName: DetailsPageComponents.AltAccoFoodDining,
          destination: '',
        },
      }),
    );
  };

  const sliderComponent = images => {
    if (!isValidArray(images)) {
      return null;
    }
    return <DiningCarousel images={images}></DiningCarousel>;
  };

  const renderedTpl = useMemo(() => {
    let tpl = null;
    if (!!allRules?.length) {
      tpl = (
        <S.Container>
          {allRules?.slice(0, 3)?.map((item, index) => (
            <S.DiningCol key={index}>
              {item?.description?.length > 0 ? (
                <S.DiningTitle>{item.description}</S.DiningTitle>
              ) : null}
              {item?.rules?.length > 0 ? (
                <S.DiningList>
                  {item?.rules
                    ?.slice(0, 3)
                    ?.map((lst, idx) => (
                      <li key={idx} dangerouslySetInnerHTML={{__html: lst.text}} />
                    ))}
                </S.DiningList>
              ) : null}
            </S.DiningCol>
          ))}
        </S.Container>
      );
    } else if (!!data?.length) {
      tpl = data?.map(item => (
        <S.SummaryContainer>
          <S.GreyDot />
          <S.SummaryItem>{item}</S.SummaryItem>
        </S.SummaryContainer>
      ));
    }
    return tpl;
  }, [allRules, data]);

  return (
    <>
      <S.SingleRestaurentUI id={detailsNavigationIds.foodDining}>
        <S.DiningHeader dangerouslySetInnerHTML={{__html: header}} />
        <S.SingleFoodWrapper>{renderedTpl}</S.SingleFoodWrapper>
        {!!allRules?.length ? (
          <S.ViewAllButton onClick={onViewAllClick}>View More Details</S.ViewAllButton>
        ) : null}
      </S.SingleRestaurentUI>
      <Modal
        isOpen={isModalOpen}
        closeModal={closeModal}
        modalStyles={{
          width: '74rem',
        }}
      >
        <DinningModalUI
          data={allRules}
          header={header}
          sliderComponent={sliderComponent}
        ></DinningModalUI>
      </Modal>
    </>
  );
};

export default DiningUI;
